import styled from 'styled-components';
import 'react-datepicker/dist/react-datepicker.css';
import View from '@sdk/components/primitives/View';
import FlexCenteredStyle from '@sdk/components/ui/FlexCenteredStyle';
import Column from '@sdk/components/ui/spacing/Column';
import TextInputBase from '@sdk/components/forms/TextInputBase';
import IconButton from '@sdk/components/ui/buttons/IconButton';

export const InputWithPointer = styled(TextInputBase)`
  cursor: pointer;
`;

export const ChevronContainer = styled(View)`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  padding-right: 14px;
  ${FlexCenteredStyle};
`;

export const Container = styled(Column)<{ customWidth?: number }>`
  position: relative;
  border-radius: 4px;
  flex: 1;
  cursor: pointer;
  ${({ customWidth }): string => (customWidth ? `width: ${customWidth}px;` : '')}
`;

export const InputContainer = styled(Column)`
  position: relative;
  cursor: pointer;
  background: ${({ theme }): string => theme.colors.white};
  flex: 2;
`;

export const DatePickerFieldContainer = styled.div`
  color: red;

  .react-datepicker-wrapper {
    display: flex;
  }

  .react-datepicker {
    font-family: 'Open Sans';
    font-size: 12px;
    padding: 20px 10px 10px;
    background: ${({ theme }) => theme.colors.white};
    box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.12);
    border-radius: 6px;
    border: none;
    color: ${({ theme }) => theme.colors.primaryText};
  }

  .react-datepicker__day--keyboard-selected,
  .react-datepicker__month-text--keyboard-selected,
  .react-datepicker__quarter-text--keyboard-selected,
  .react-datepicker__year-text--keyboard-selected {
    border-radius: ininial;
    background-color: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.primaryText};
  }

  .react-datepicker__day--disabled,
  .react-datepicker__month--disabled,
  .react-datepicker__year-text--disabled {
    background-color: ${({ theme }) => theme.colors.button10Overlay} !important;
    color: #ccc;
  }

  .react-datepicker__header {
    padding: 0;
    background: none;
    border: none;
  }

  .react-datepicker__day-names {
    margin: 0;
  }

  .react-datepicker-popper .react-datepicker__triangle:before,
  .react-datepicker-popper .react-datepicker__triangle:after {
    border-bottom-color: ${({ theme }) => theme.colors.white};
  }

  .react-datepicker__day-name {
    font-size: 12px;
    color: ${({ theme }) => theme.colors.iconGray};
  }

  .react-datepicker__day {
    color: ${({ theme }) => theme.colors.primaryText};
  }

  .react-datepicker__day-name,
  .react-datepicker__day,
  .react-datepicker__time-name {
    padding: 4px;
    margin: 0;
    border-radius: 2px;
    width: calc(100% / 7);
  }

  .react-datepicker__month {
    margin: 0;
  }

  .react-datepicker__day--today,
  .react-datepicker__month-text--today,
  .react-datepicker__year-text--today {
    background: ${({ theme }) => theme.colors.white};
    font-weight: normal;
  }

  .react-datepicker__day--selected,
  .react-datepicker__month--selected,
  .react-datepicker__year-text--selected {
    background: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.primaryText};
    font-weight: normal;
    box-shadow: 0 0 0 1px ${({ theme }) => theme.colors.primary} inset;
  }

  .react-datepicker__day--today,
  .react-datepicker__month-text--today,
  .react-datepicker__year-text--today {
    color: ${({ theme }) => theme.colors.primary};
  }

  .react-datepicker__day:not(.react-datepicker__day--disabled):hover,
  .react-datepicker__month-text:hover,
  .react-datepicker__year-text:not(.react-datepicker__year-text--disabled):hover {
    background: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.white};
    font-weight: normal;
  }

  .react-datepicker__day--outside-month {
    color: ${({ theme }) => theme.colors.iconGray};
  }

  .react-datepicker__month .react-datepicker__month-text,
  .react-datepicker__month .react-datepicker__quarter-text {
    width: calc(100% / 3);
    height: 26px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin: 0;
  }

  .react-datepicker__year-text {
    width: calc(100% / 4);
    height: 26px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin: 0;
  }

  .react-datepicker__triangle {
    display: none;
  }

  .react-datepicker-popper[data-placement='bottom-start'] {
    padding: 0;
  }

  .react-datepicker-popper[data-placement='top-start'] {
    padding: 0;

    .react-datepicker {
      transform: translateY(22px);
    }
  }

  .react-datepicker__month-container,
  .react-datepicker__year--container {
    width: 270px;
  }

  .react-datepicker__year-wrapper {
    max-width: none;
  }
`;

export const TrashButton = styled(IconButton)`
  max-width: 36px;
  margin-left: 10px;
  background-color: ${({ theme }) => theme.colors.white};
`;
